import { useNavigate } from 'react-router-dom';

import { GenericButton } from '@shared/components/ui/custom';

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center px-4 py-16 text-center">
      <h1 className="text-9xl font-extrabold tracking-tight text-muted-foreground/20">404</h1>
      <h2 className="mt-4 text-3xl font-bold tracking-tight sm:text-5xl">Page not found</h2>
      <p className="mt-6 text-base leading-7 text-muted-foreground">Sorry, the page you visited does not exist.</p>
      <div className="mt-10">
        <GenericButton onClick={() => navigate('/')} variant={'default'} label="Back to Home" />
      </div>
    </div>
  );
};
